<template>
  <div class="ic-card">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">

          <p class="order-title-boxs"><span class="blueBlock"></span><i>IC卡信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">IC卡号</div>
              <div class="itemNum">{{ form.cardLogicno }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记姓名</div>
              <div class="itemNum">{{ form.username }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记号码</div>
              <div class="itemNum">{{ form.userTel }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">会员姓名</div>
              <div class="itemNum">{{ form.memberName }}</div>
            </div>
           <div class="flex-row mb30">
              <div class="itemName">会员手机号</div>
              <div class="itemNum">{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡类型</div>
              <div class="itemNum">{{ form.turnStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡金额</div>
              <div class="itemNum moneys" v-if="form.amount">￥{{ form.amount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">操作人</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡时间</div>
              <div class="itemNum">{{ formatDate(form.turnDate) }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>审核信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核人</div>
              <div class="itemNum">{{ form.auditStaffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核时间</div>
              <div class="itemNum">{{ formatDate(form.auditTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核备注</div>
              <div class="itemNum">{{ form.auditRemark }}</div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="pr24 pb10">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "IC详情",
      addEditShow: false,
      form: {},
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.icCardRecord.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.form = res;
            }
          });
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

</style>